import axios from 'axios';

let axiosInstance = null;


const Config = () => {

  if (!axiosInstance) {
    axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
      withCredentials: true,
    });
  }

  return axiosInstance;
};
export default Config;
